import { lazy, Suspense, useRef, useState } from "react";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Manifesto from "./components/Manifesto";
import Growth from "./components/Growth";
import Certainty from "./components/Certainty";
import Pillars from "./components/Pillars";
import Stats from "./components/Stats";
import StatsSecond from "./components/StatsSecond";
import StatsCTAs from "./components/StatsCTAs";
import AIBalance from "./components/AIBalance";
import Quote from "./components/Quote";
import Journal from "./components/Journal";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import { DEFAULT_PARAMS, type GrassParams } from "./components/grassParams";
import SettingsPanel from "./components/SettingsPanel";
import GalleryModal from "./components/GalleryModal";
import PhoneGag from "./components/PhoneGag";
import { useScrollReveal } from "@/hooks/useScrollReveal";

// The WebGL field (and with it three.js) is fetched after the first paint.
const GrassScene = lazy(() => import("./components/GrassScene"));
import { useScrollProgress } from "@/hooks/useScrollProgress";

export default function Home() {
  useScrollReveal();
  const progress = useScrollProgress();
  const paramsRef = useRef<GrassParams>({ ...DEFAULT_PARAMS });
  const [galleryOpen, setGalleryOpen] = useState(false);

  return (
    <main className="relative min-h-screen text-ink font-body overflow-x-hidden">
      {/* Live WebGL grass field as fixed background */}
      <Suspense
        fallback={
          <div
            className="fixed top-[18vh] inset-x-0 bottom-0 z-0 bg-white"
            aria-hidden="true"
          />
        }
      >
        <GrassScene paramsRef={paramsRef} />
      </Suspense>

      {/* Comic phone gag floating in the grass */}
      <PhoneGag />

      <Nav progress={progress} />
      <div className="relative z-10">
        <Hero />
        <Manifesto />
        <Growth />
        <Certainty />
        <Pillars />
        <Stats />
        <StatsSecond />
        <StatsCTAs onViewGallery={() => setGalleryOpen(true)} />
        <AIBalance />
        <Quote />
        <Journal />
        <CTA />
        <Footer />
      </div>

      <SettingsPanel paramsRef={paramsRef} />

      <GalleryModal
        open={galleryOpen}
        onClose={() => setGalleryOpen(false)}
      />
    </main>
  );
}